import { useCohort } from '@/components/user-context/helpers/cohorts.ts';
import { useIsMobile } from '@/utils/useIsMobile';

import { SignupDefault } from '../../../components/signup-default';
import { LoggedInLoomExistingSitesUser } from '../existing-sites-user';
import { LoggedInLoomNewUser } from '../new-user';

export const LoggedInLoom = () => {
	const cohort = useCohort();
	const isMobile = useIsMobile(800);

	// Cohort not resolved yet (profile request in progress)
	if (cohort === undefined) {
		return null;
	}

	// Mobile always falls back to the default signup.
	if (isMobile) {
		return <SignupDefault />;
	}

	if (cohort === 'new-user') {
		return <LoggedInLoomNewUser />;
	}

	// Every other logged-in cohort (existing-sites, managed-user, week-one-user and
	// upgrade-eligible-user) gets the lofi Loom-backdrop site-activation form.
	return <LoggedInLoomExistingSitesUser />;
};
